export const Brand = ({ light = false, size = "md", showText = true }) => {
  const dim = size === "lg" ? "h-11" : size === "sm" ? "h-7" : "h-9";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <img
        src={light ? "/brand/logo-icon-white-112.webp" : "/brand/logo-icon-112.webp"}
        width={158}
        height={112}
        decoding="async"
        fetchPriority="high"
        alt="Transfiérelo"
        className={`${dim} w-auto select-none`}
        draggable={false}
        data-testid="brand-logo-icon"
      />
      {showText && (
        <span className={`font-display font-extrabold tracking-tight ${text} ${light ? "text-white" : "text-[#13315C]"}`}>
          Transfiére<span className="text-[#F5B301]">lo</span>
        </span>
      )}
    </div>
  );
};
